import React, { useState } from 'react'
import './CreateTreck.css'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useFormik } from 'formik';
import * as Yup from 'yup';

const CreateTreck = () => {
  // Pickup points and food options that the admin configures for this trek.
  // These get encoded into the shareable application-form link as query params.
  const [pickupPoints, setPickupPoints] = useState([""]);
  const [foodOptions, setFoodOptions] = useState([""]);
  const [generatedLink, setGeneratedLink] = useState("");
  const [copied, setCopied] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [linkNote, setLinkNote] = useState("");

  const updateListItem = (list, setList, index, value) => {
    const updated = [...list];
    updated[index] = value;
    setList(updated);
  };

  const addListItem = (list, setList) => setList([...list, ""]);

  const removeListItem = (list, setList, index) => {
    if (list.length === 1) return;
    setList(list.filter((_, i) => i !== index));
  };

  const generateLink = async () => {
    const trekName = formik.values.name.trim();
    if (!trekName) {
      formik.setFieldTouched("name", true);
      formik.setFieldError("name", "Trek name is required to generate a link");
      return;
    }

    const pickups = pickupPoints.map((p) => p.trim()).filter(Boolean);
    const foods = foodOptions.map((f) => f.trim()).filter(Boolean);

    const params = new URLSearchParams();
    params.set("trek", trekName);
    if (pickups.length) params.set("pickups", pickups.join(","));
    if (foods.length) params.set("foods", foods.join(","));

    const longLink = `${window.location.origin}/?${params.toString()}`;

    setGenerating(true);
    setCopied(false);
    setLinkNote("");

    try {
      // Ask the backend to shorten the link so admins get a tidy URL to share.
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/shorten`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ url: longLink, trekName }),
        }
      );
      if (!res.ok) throw new Error("Failed to shorten link");
      const data = await res.json();
      setGeneratedLink(data.shortUrl || longLink);
    } catch (err) {
      // If the shortener is unreachable, still give the admin a working link.
      setGeneratedLink(longLink);
      setLinkNote("Couldn't shorten the link right now — showing the full URL instead.");
    } finally {
      setGenerating(false);
    }
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(generatedLink);
      setCopied(true);
    } catch (err) {
      setCopied(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      location: "",
      duration: "",
      date: "",
      price: "",
      description: "",
      contact: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Required"),
      location: Yup.string().required("Required"),
      duration: Yup.string().required("Required"),
      date: Yup.string().required("Required"),
      price: Yup.number().required("Required").min(0),
      description: Yup.string().required("Required"),
      contact: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      console.log("Trek Submitted:", values);
      alert("Trek added successfully!");
      // send to backend using fetch/axios
    },
  });

  return (
    <div className='createTreckMain'>
      <div className="createTreckSub">
        <form onSubmit={formik.handleSubmit} style={{ maxWidth: "100%" }}>
          <h2>Add New Trek</h2>
          <div className="createTreckForm">
            <div className="formInput">
              <label htmlFor="">Trek Name</label>
              <input type="text" name="name" placeholder="Trek Name" {...formik.getFieldProps("name")} />
              {formik.touched.name && formik.errors.name && <div>{formik.errors.name}</div>}
            </div>

            <div className="formInput">
              <label htmlFor="">Location</label>
              <input type="text" name="location" placeholder="Location" {...formik.getFieldProps("location")} />
              {formik.touched.location && formik.errors.location && <div>{formik.errors.location}</div>}
            </div>

            <div className="formInput">
              <label htmlFor="">Duration</label>
              <input type="text" name="duration" placeholder="Duration (e.g., 3 days)" {...formik.getFieldProps("duration")} />
              {formik.touched.duration && formik.errors.duration && <div>{formik.errors.duration}</div>}
            </div>

            <div className="formInput">
              <label htmlFor="">Date</label>
              <input type="date" name="date" {...formik.getFieldProps("date")} />
              {formik.touched.date && formik.errors.date && <div>{formik.errors.date}</div>}
            </div>

            <div className="formInput">
              <label htmlFor="">Price</label>
              <input type="number" name="price" placeholder="Price" {...formik.getFieldProps("price")} />
              {formik.touched.price && formik.errors.price && <div>{formik.errors.price}</div>}
            </div>

            <div className="formInput">
              <label htmlFor="">Conatct Number</label>
              <input type="text" name="contact" placeholder="Contact Info" {...formik.getFieldProps("contact")} />
              {formik.touched.contact && formik.errors.contact && <div>{formik.errors.contact}</div>}
            </div>

              <div className="formInput" style={{width:"100%"}}>
              <label htmlFor="">Trek Description</label>
              <textarea name="description" placeholder="Trek Description" {...formik.getFieldProps("description")}></textarea>
              {formik.touched.description && formik.errors.description && <div>{formik.errors.description}</div>}
            </div>

            {/* Pickup points the admin wants to offer for this trek */}
            <div className="formInput dynamicListGroup" style={{ width: "100%" }}>
              <label>Pickup Points</label>
              {pickupPoints.map((point, index) => (
                <div className="dynamicListRow" key={`pickup-${index}`}>
                  <input
                    type="text"
                    placeholder={`Pickup Point ${index + 1}`}
                    value={point}
                    onChange={(e) =>
                      updateListItem(pickupPoints, setPickupPoints, index, e.target.value)
                    }
                  />
                  <button
                    type="button"
                    className="listRemoveBtn"
                    onClick={() => removeListItem(pickupPoints, setPickupPoints, index)}
                    disabled={pickupPoints.length === 1}
                  >
                    &times;
                  </button>
                </div>
              ))}
              <button
                type="button"
                className="listAddBtn"
                onClick={() => addListItem(pickupPoints, setPickupPoints)}
              >
                + Add Pickup Point
              </button>
            </div>

            {/* Food options the admin wants to offer for this trek */}
            <div className="formInput dynamicListGroup" style={{ width: "100%" }}>
              <label>Food Options</label>
              {foodOptions.map((food, index) => (
                <div className="dynamicListRow" key={`food-${index}`}>
                  <input
                    type="text"
                    placeholder={`Food Option ${index + 1}`}
                    value={food}
                    onChange={(e) =>
                      updateListItem(foodOptions, setFoodOptions, index, e.target.value)
                    }
                  />
                  <button
                    type="button"
                    className="listRemoveBtn"
                    onClick={() => removeListItem(foodOptions, setFoodOptions, index)}
                    disabled={foodOptions.length === 1}
                  >
                    &times;
                  </button>
                </div>
              ))}
              <button
                type="button"
                className="listAddBtn"
                onClick={() => addListItem(foodOptions, setFoodOptions)}
              >
                + Add Food Option
              </button>
            </div>

            {/* For image uploads, you can handle with a file input separately */}
            <div className="addTrekBtn">
              <button type="submit">Add Trek</button>
              <button
                type="button"
                className="generateLinkBtn"
                onClick={generateLink}
                disabled={generating}
              >
                {generating ? "Generating…" : "Generate Trek Link"}
              </button>
            </div>

            {generatedLink && (
              <div className="generatedLinkBox" style={{ width: "100%" }}>
                <label>🔗 Shareable Short Link</label>
                <div className="generatedLinkRow">
                  <input type="text" value={generatedLink} readOnly />
                  <button type="button" onClick={copyLink}>
                    {copied ? "Copied!" : "Copy"}
                  </button>
                </div>
                {linkNote && <p className="linkNote">{linkNote}</p>}
                <a href={generatedLink} target="_blank" rel="noopener noreferrer">
                  Open form ↗
                </a>
              </div>
            )}

          </div>
        </form>


      </div>
    </div >
  )
}

export default CreateTreck